<template>
    <div>
        <Loading v-bind:show="showLoading">
            <div>
                <md-content>
                    <div v-if="name == 'Ativos'">

                        <div style="clear:both"><br /></div>
                        <p class="titulo s-h2">Resumo</p>

                        <Info Titulo=""
                              v-bind:Informacao="totalDebito"
                              Descricao="TOTAL DE DÉBITOS"
                              BordaCor="6361fb"
                              Tipo="moeda" />

                        <h2 class="divOperacao">-</h2>

                        <Info Titulo=""
                              v-bind:Informacao="totalPago"
                              Descricao="TOTAL PAGO"
                              BordaCor="transparent"
                              Tipo="moeda" />

                        <h2 class="divOperacao">-</h2>

                        <Info Titulo=""
                              v-bind:Informacao="totalBaixado"
                              Descricao="TOTAL BAIXADO"
                              BordaCor="transparent"
                              Tipo="moeda" />

                        <h2 class="divOperacao">=</h2>

                        <Info Titulo=""
                              v-bind:Informacao="totalAberto"
                              Descricao="TOTAL ABERTO"
                              BordaCor="transparent"
                              Tipo="moeda" />

                    </div>
                    <div style="clear:both"></div>

                    <Loading v-bind:show="showLoading">
                        <md-table v-model="searched" :md-sort="OrderBy" md-sort-order="asc" md-card @md-selected="onSelect" class="semMargin">
                            <md-table-toolbar>

                                <div class="md-layout md-gutter">
                                    <div class="md-layout-item" v-if="exibirCombo1 == true">
                                        <md-field>
                                            <label for="combo1" class="color6361FB">{{detalhesCombo1.titulo}}</label>
                                            <md-select v-model="combo1" name="combo1" id="combo1" @md-selected="changeCombo(combo1, 1)" class="filtro" style="color:#6361FB !important">
                                                <md-option :value="c.value" v-for="c in detalhesCombo1.dados" :key="c.value" class="option">
                                                    {{c.text}}
                                                </md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item" v-if="exibirCombo2">
                                        <md-field>
                                            <label for="combo1" class="color6361FB">{{detalhesCombo2.titulo}}</label>
                                            <md-select name="combo2" id="combo2" v-model="combo2" @md-selected="changeCombo(combo2, 2)" class="filtro">
                                                <md-option :value="c.value" v-for="c in detalhesCombo2.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                            </md-select>
                                        </md-field>
                                    </div>

                                    <div class="md-layout-item" v-if="exibirCombo3">
                                        <md-field>
                                            <label for="combo1" class="color6361FB">{{detalhesCombo3.titulo}}</label>
                                            <md-select name="combo3" id="combo3" v-model="combo3" @md-selected="changeCombo(combo3, 3)" class="filtro">
                                                <md-option :value="c.value" v-for="c in detalhesCombo3.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                </div>

                                <div class="md-layout-item padding-pesquisar align-right">
                                    <md-field class="md-toolbar-section-end">
                                        <md-input placeholder="Pesquisar..." v-model="search" @input="searchOnTable" class="filtro color6361FB webkit-text-fill-color6361FB" />
                                        <button v-on:click="limparPesquisa" class="buttonLimpar">
                                            <md-icon>backspace</md-icon>
                                            <md-tooltip md-direction="top">Limpar pesquisa</md-tooltip>
                                        </button>
                                    </md-field>
                                </div>

                            </md-table-toolbar>
                            <md-table-empty-state md-label="Nenhum resultado encontrado"
                                                  :md-description="`Nenhum registro encontrado. Tente pesquisar com outra informação.`">
                            </md-table-empty-state>

                                
                            <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single">
                                <md-table-cell :md-label="c.Titulo" :md-sort-by="c.Field" :v-width="c.width" v-for="c in Header" :key="c.Field">

                                    <p class="s-h4 regular" v-on:click="exibirDetalhes(item)" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'texto'">{{item[c.Field]}}</p>

                                    <p class="s-h4 regular" style="text-align:center" v-on:click="exibirDetalhes(item)" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'numero'">{{item[c.Field]}}</p>

                                    <p class="s-h4 regular" style="text-align:center" v-on:click="exibirDetalhes(item)" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'date'" v-formatdate="item[c.Field]"></p>

                                    <p class="s-h4 regular" style="text-align:center" v-on:click="exibirDetalhes(item)" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'dataTime'" v-formatdatetime="item[c.Field]"></p>

                                    <p class="s-h4 regular" style="text-align:center" v-on:click="exibirDetalhes(item)" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'moeda'" v-formatmoeda="item[c.Field]"></p>

                                    <div md-label="Acessar" v-if="c.Titulo =='Link'" width="30px">
                                        <button v-on:click="acessarLink(item[c.Field])"><md-icon>link</md-icon></button>
                                    </div>
                                </md-table-cell>
                            </md-table-row>

                        </md-table>
                    </Loading>
                    <div class="md-toolbar-section-start padding-20" v-if="Title">

                    </div>

                    <div v-if="selected" class="padding-20"  style="color:#fff">
                        <p><strong>Linha selecionada:</strong></p>
                        {{ selected }}
                    </div>
                    <md-dialog :md-active.sync="carregarDetalhes" class="md-layout-item md-size-50 zindex">
                        <div class="padding-20">
                            <h2>Mais informações</h2>

                            <div v-for="c in HeaderDetalhes" :key="c.Field">
                                <div v-for="a in valorDetalhes" :key="a.Titulo">
                                    <div v-if="a[c.Field] != null && a[c.Field] != ''">
                                        <p v-if="c.Tipo == 'texto' || c.Tipo == 'numero'"><strong>{{c.Titulo}}: </strong> {{a[c.Field]}}</p>

                                        <p v-if="c.Tipo == 'date'"><strong>{{c.Titulo}}: </strong> <span v-formatdate="a[c.Field]"></span></p>
                                        <p v-if="c.Tipo == 'dataTime'"><strong>{{c.Titulo}}: </strong> <span v-formatdatetime="a[c.Field]"></span></p>
                                        <p v-if="c.Tipo == 'moeda'"><strong>{{c.Titulo}}: </strong> <span v-formatmoeda="a[c.Field]"></span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <md-dialog-actions>
                            <md-button class="md-primary" @click="carregarDetalhes = false">Fechar</md-button>
                        </md-dialog-actions>
                    </md-dialog>
                </md-content>


                <md-dialog-actions >
                    <button class="buttonCarne s-h3" v-on:click="visualizarCarne" v-if="botaoCarne">Visualizar Carnê<md-icon class="iconeHistoricoAceite">arrow_forward_ios</md-icon></button>
                </md-dialog-actions>
            </div>
        </Loading>
    </div>
</template>

<script>

    import { formatdatetime } from '@/directives/formatdatetime.js';
    import { formatdate } from '@/directives/formatdate.js';
    import { formatmoeda } from '@/directives/formatmoeda.js';
    import CarneService from '@/services/CarneService.js';
    import Info from '@/components/Info';
    import Loading from '@/components/Loading';
    import Button from '@/services/ButtonService.js';

    export default {
        name: 'GridCarnes',
        components: {
            Loading,
            Info
        },
        directives: {
            formatdatetime,
            formatdate,
            formatmoeda
        },
        props: {
            Data: {
                type: Object
            },
            Header: {
                type: Array
            },
            Name: String,
            Title: String,
            OrderBy: String,
            HeaderDetalhes: {
                type: Array
            },
            DetalhesCombo1: {
                type: Object
            },
            DetalhesCombo2: {
                type: Object
            },
            DetalhesCombo3: {
                type: Object
            }
        },
        data:
            function () {
                return {
                    selected: null,
                    dados: this.Data,
                    headers: this.Header,
                    name: this.Name,
                    search: '',
                    headerDetalhes: this.HeaderDetalhes,
                    carregarDetalhes: false,
                    detalhesCombo1: this.DetalhesCombo1,
                    detalhesCombo2: this.DetalhesCombo2,
                    detalhesCombo3: this.DetalhesCombo3,
                    exibirCombo1: false,
                    exibirCombo2: false,
                    exibirCombo3: false,
                    valorDetalhes: [],
                    valorPesquisaCombo: [],
                    combo1: '',
                    combo2: '',
                    combo3: '',
                    showLoading: false,
                    showLoadingGerarCarne: false,
                    searched: null,
                    totalDebito: 0,
                    totalPago: 0,
                    totalBaixado: 0,
                    totalAberto: 0,
                    botaoCarne: false
                }
            },

        methods: {
            getClass: () => ({
                'md-primary': 2
            }),
            onSelect(item) {
                this.selected = item;
            },

            limparPesquisa() {
                this.valorPesquisaCombo = [];
                this.combo1 = "";
                this.combo2 = "";
                this.combo3 = "";
                if (this.name == "Ativo")
                    this.searched = this.dados.carneDetalhado;
                else
                    this.searched = this.data.dados.deletados;
                this.search = "";
            },

            exibirDetalhes(valor) {
                this.valorDetalhes = [];
                if (this.headerDetalhes != null) {
                    this.valorDetalhes.push(valor);
                    this.carregarDetalhes = !this.carregarDetalhes;
                }
            },

            visualizarCarne() {
                  this.showLoadingGerarCarne = true;
                this.buttonService = new Button(this);
              
                this.buttonService.Acao({
                    Parametros: this.dados.carne,
                    Servico: "Financeiro",
                    Metodo: "GerarBoleto",
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoTurma: this.aluno.codigoTurma,
                    CodigoEmpresa: this.aluno.codigoEmpresa
                }).then(
                    data => {
                        if (data.ok) {
                            let download = data.dados;

                            this.$modal.info("O arquivo foi carregado em uma nova aba. Caso o mesmo não seja carregado, verificar se o bloqueio de pop-up está desabilitado para esse site.");
                            window.open("http://boleto.pdf").document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64," + encodeURI(download) + "'></iframe>");
                        }
                        else {
                            this.$modal.alert(data.mensagem);
                        }
                    },
                    error => {
                        this.$modal.error('Ocorreu um erro ao executar a ação.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                    }).finally(() => {
                        this.showLoadingGerarCarne = false;
                    });
            },

            changeCombo(valor, combo) {

                if (combo == 1) {
                    this.carneService = new CarneService(this);

                    //Popula os dados da aba
                    this.showLoading = true;
                    this.carneService.ExtratoFinanceiroDetalhe({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoEmpresa: this.aluno.codigoEmpresa,
                        Titulo: this.dados.carne.codigo_Titulo,
                        TipoTitulo: "CAR",
                        CodigoPeriodo: valor
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dados = data.dados;
                                this.carregarDadosAtivos();
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });

                }
                else
                    this.valorPesquisaCombo.push({ Combo: combo, Valor: valor.toString() });
                this.searchOnTable();
            },

            searchOnTable() {

                this.searched = [];
                this.searched = this.dados.carneDetalhado;
                let valorAntigo = ''
                if (this.search) {
                    valorAntigo = this.search;
                    this.searched = this.dados.filter(contemTexto(this.search, this.headers));
                }

                if (this.valorPesquisaCombo.length > 0) {

                    for (var i = 0; i < this.valorPesquisaCombo.length; i++) {
                        this.search = this.valorPesquisaCombo[i].Valor;
                        this.searched = this.searched.filter(contemTexto(this.search, this.headers));
                    }

                    this.search = valorAntigo;
                }
            },

            carregarDadosAtivos() {
                this.totalDebito = this.dados.totalDebitos.toString();
                this.totalPago = this.dados.totalPago.toString();
                this.totalBaixado = this.dados.totalAberto.toString();
                this.totalAberto = this.dados.totalAberto.toString();
                this.searched = this.dados.carneDetalhado;

                this.botaoCarne = this.dados.carne.situacao.toLowerCase() == "em aberto"
                    || this.dados.carne.situacao.toLowerCase() == "emaberto"
                    this.dados.carne.situacao.toLowerCase() == "aberto";
            }
        },
        created() {
            this.searched = [];

            if (this.name == "Ativos") {
                this.carregarDadosAtivos();

                this.combo1 = this.detalhesCombo1.dados[1].value;
            }

            if (this.detalhesCombo1 != null && this.detalhesCombo1.titulo != undefined) {
                this.exibirCombo1 = true;
            }

            if (this.detalhesCombo2 != null && this.detalhesCombo2.titulo != undefined)
                this.exibirCombo2 = true;

            if (this.detalhesCombo3 != null && this.detalhesCombo3.titulo != undefined)
                this.exibirCombo3 = true;

            let a = JSON.parse(sessionStorage.Aluno);
            this.aluno = a.PerfilAluno;
        }
    }

    function contemTexto(search, headers) {
        return function (element) {

            for (var i = 0; i < headers.length; i++) {
                if (element[headers[i].Field] && element[headers[i].Field].toString().toLowerCase().includes(search.toLowerCase()))
                    return true;
            }

            return false;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .grid {
        width: 30em;
        overflow-x: auto;
        white-space: pre-wrap;
    }

    .theme-default {
        background-color: #9b9b9b;
        color: white;
    }

    .theme-primary {
        background-color: #448aff;
        color: white;
    }

    .theme-success {
        background-color: #009688;
        color: white;
    }

    .theme-danger {
        background-color: #ff5252;
        color: white;
    }

    .theme-warning {
        background-color: #f9aa33;
        color: white;
    }

    .align-right {
        float: right;
        padding: 20px;
    }

    .padding-20 {
        padding: 0 0 10px 20px;
    }

    .padding-pesquisar {
        padding: 0 0 0 40px;
    }


    .md-table-cell-container {
        padding: 0px;
    }

    .zindex {
        z-index: 1000;
    }

    .buttonLimpar {
        background-color: transparent;
        border: 0;
    }

    .filtro {
        height: 40px !important;
        font-size: 20px !important;
    }

    .color6361FB {
        color: #6361FB !important;
    }

    .option {
        background-color: #fff !important;
    }

        .option:hover {
            background-color: #6361FB !important;
        }

    .webkit-text-fill-color6361FB {
        -webkit-text-fill-color: #6361FB !important;
    }

    .border6361FB {
        border-bottom-color: #6361FB !important;
    }

    .semMargin {
        padding: 0 !important;
        margin: 0 !important;
    }

    .titulo {
        margin: 0;
        padding: 0 0 0 15px;
        font-weight: bold;
    }


    .divHorario {
        float: left;
        position: relative;
        display: inline;
        width: 300px;
        padding: 0 10px 10px 10px;
    }

    .divOperacao {
        width: 30px;
        float: left;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }


    .divHistoricoAceite {
        z-index: 1000;
        width: 90%;
        height: 500px;
        overflow-y: auto;
        padding: 20px;
    }

    .buttonHistoricoAceite {
        background-color: #8629ff;
        border-radius: 5px;
        color: #fff;
        font-size: 13px;
        margin-top: 10px;
        padding: 10px;
        font-weight: bold;
    }

    .iconeHistoricoAceite {
        color: #fff !important;
        padding: 0 10px 0 20px;
    }

    .semestralizado {
        width: 218px;
        margin-left: 1px;
        padding-top: 0px;
    }

    .buttonCarne {
        background-color: #6361FB;
        border-radius: 5px;
        color: #fff;
        margin-top: 0px;
        padding: 10px;
        border: 0px;
    }
</style>
